import {
  AuthBaseStore,
  DATEFNS_PERSIAN_DATE_FORMATS,
  DatefnsJalaliDateAdapter,
  DIALOG_INVOKER_CONFIG,
  DialogService,
  ICON_COMPONENT_CONFIG,
  IMAGE_UPLOADER_COMPONENT_CONFIG,
  provide,
  provideCacBase,
  SnackbarService,
} from '@controladad/ng-base';
import { DialogExtendedService } from './dialog/dialog-extended.service';
import { environment } from '../environments/environment';
import { AuthStore } from './core';
import { provideFormErrors } from '@al00x/forms';
import localeFa from '@angular/common/locales/fa';
import { SnackbarExtendedService } from './core/services/snackbar-extended.service';
import { faIR } from 'date-fns-jalali/locale';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DefaultMatCalendarRangeStrategy, MAT_DATE_RANGE_SELECTION_STRATEGY } from '@angular/material/datepicker';

export const provideCac = () => [
  provideCacBase({
    applicationName: 'FST Asset Tracking',
    environment: environment,
    localization: {
      langs: ['fa'],
      localesPath: '/assets/locales/',
      localesData: {
        fa: {
          localeData: localeFa
        }
      }
    },
    apiBaseUrl: environment.apiBaseUrl,
  }),
  { provide: DialogService, useClass: DialogExtendedService },
  { provide: AuthBaseStore, useClass: AuthStore },
  { provide: SnackbarService, useClass: SnackbarExtendedService },
  { provide: MAT_DATE_LOCALE, useValue: faIR },
  { provide: MAT_DATE_FORMATS, useValue: DATEFNS_PERSIAN_DATE_FORMATS },
  { provide: DateAdapter, useClass: DatefnsJalaliDateAdapter, deps: [MAT_DATE_LOCALE] },
  {
    provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
    useClass: DefaultMatCalendarRangeStrategy,
  },
  provide(ICON_COMPONENT_CONFIG, {
    size: '1.5rem',
    strokeWidth: 1.5,
  }),
  provide(DIALOG_INVOKER_CONFIG, {
    backdropBlur: 'sm',
  }),
  provide(IMAGE_UPLOADER_COMPONENT_CONFIG, {
    label: 'Upload Image',
    accept: '.png,.jpeg,.jpg',
  }),
  provideFormErrors({
    required: 'این فیلد الزامی می باشد.',
    email: 'این ایمیل درست نیست.',
    unmatched: 'مقدار این فیلد مطابقت ندارد.',
    passwordLength: 'پسورد باید ۸ کاراکتر یا بیشتر باشد.',
    passwordChars: 'پسورد باید شامل حروف و اعداد باشد.',
    default: 'مقدار این فیلد اشتباه میباشد.',
  }),
];
